// PROPOSITO: los toasts. Lo que sustituye a alert() en toda la app.
// DEPENDENCIAS: src/store/ui.
// NO OBVIO: vive en el layout, no en las pantallas. Si viviera en una pantalla, desapareceria al
// navegar justo cuando mas hace falta — al terminar una accion que cambia de pagina.

import { usarUI } from '@/store/ui'
import type { TonoDeAviso } from '@/store/ui'

const ESTILO: Record<TonoDeAviso, string> = {
  exito: 'bg-exito-contenedor text-exito-sobre-contenedor border-exito',
  error: 'bg-peligro-contenedor text-peligro-sobre-contenedor border-peligro',
  info: 'bg-info-contenedor text-info-sobre-contenedor border-info',
}

export function Avisos() {
  const avisos = usarUI(e => e.avisos)
  const descartar = usarUI(e => e.descartar)

  if (avisos.length === 0) return null

  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-toast flex flex-col gap-2 p-4 pb-[calc(1rem+env(safe-area-inset-bottom))]"
    >
      {avisos.map(aviso => (
        <button
          key={aviso.id}
          type="button"
          onClick={() => { descartar(aviso.id) }}
          className={`w-full rounded-lg border p-4 text-left text-sm shadow-md ${ESTILO[aviso.tono]}`}
        >
          {aviso.texto}
        </button>
      ))}
    </div>
  )
}
